import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private parentData = new BehaviorSubject<any>({ name: 'John', age: 30 })
  currentData = this.parentData.asObservable()

  changeData (data: any): void {
    this.parentData.next(data)
  }
}
